import { gql } from "@apollo/client";

export default gql`
  mutation adminSignIn($data: SignInAdminInput!){
    adminSignIn(data: $data){
        success
        data{
            token
            user{
                _id
                name
                surname
                role
                phone
                email
                createdAt
            }
        }
        code
        message
    }
}
`
